
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/de",
      function () {
        return require("private-next-pages/de/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/de"])
      });
    }
  